import { FC } from 'react';
import { ScoreTitleStyled } from './style';

const ScoreTitle: FC<{ children?: any }> = ({ children, ...restProps }) => (
  <ScoreTitleStyled {...restProps}>{children}</ScoreTitleStyled>
);

export default ScoreTitle;
